import { styled } from '@material-ui/core';

import { RiArrowRightDownLine, RiArrowRightUpLine } from '@remixicon/react';

import { getColorByClass } from '@spotify/confidence-editor-react';

import { getColorClass } from '../../metrics';
import { MetricRow } from './types';

const ColoredValue = styled('span')((props: { colorClass: string }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  fontSize: 'var(--encore-text-size-smaller)',
  fontWeight: 600,
  color: getColorByClass(props.colorClass),
}));

const TypeBadge = styled('span')(
  (props: { type: 'guardrail' | 'success' }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: 'var(--encore-text-size-smaller)',
    padding: '4px 8px',
    borderRadius: 'var(--encore-corner-radius-base)',
    backgroundColor:
      props.type === 'guardrail'
        ? 'rgba(83, 155, 245, 0.15)'
        : 'rgba(26, 168, 76, 0.15)',
    color: props.type === 'guardrail' ? '#539BF5' : '#1AA84C',
    textTransform: 'capitalize',
    fontWeight: 500,
  }),
);

type MetricTableRowProps = {
  row: MetricRow;
  index: number;
};

const getValueIcon = (value: string, colorClass: string) => {
  // Parse the numeric value from the string (e.g., "5.2%" -> 5.2, "-3.1%" -> -3.1)
  const numericValue = parseFloat(value.replace(/[^0-9.-]/g, ''));

  if (isNaN(numericValue) || numericValue === 0) {
    return null;
  }

  const iconProps = {
    size: 16,
    style: {
      verticalAlign: 'text-bottom',
      marginRight: '4px',
      color: getColorByClass(colorClass),
    },
  };

  return numericValue > 0 ? (
    <RiArrowRightUpLine {...iconProps} />
  ) : (
    <RiArrowRightDownLine {...iconProps} />
  );
};

export const MetricTableRow = ({ row, index }: MetricTableRowProps) => {
  const colorClass = getColorClass(
    row.status,
    row.type,
    row.hasNoninferiorityMargin,
  );

  return (
    <tr key={`${row.metricId}-${index}`}>
      <td>
        <p>{row.name}</p>
      </td>
      <td>
        <p>
          <TypeBadge type={row.type}>{row.type}</TypeBadge>
        </p>
      </td>
      <td>
        <p>
          <ColoredValue colorClass={colorClass}>
            {getValueIcon(row.value, colorClass)}
            {row.value}
          </ColoredValue>
        </p>
      </td>
      <td>
        <p>{row.sampleSize}</p>
      </td>
      <td>
        <p>{row.lowerBound}</p>
      </td>
      <td>
        <p>{row.upperBound}</p>
      </td>
      <td>
        <p>
          <ColoredValue colorClass={colorClass}>{row.outcome}</ColoredValue>
        </p>
      </td>
    </tr>
  );
};
